export const POPUP_CONTENT: IPopupContent[] = [
  {
    name: 'productItem',
    title: 'Товары отобразятся автоматически',
    desc:
      'Вы можете посмотреть как отображаются ваши товары по кнопке «Предпросмотр». Если каталог товаров не успеет загрузиться, вместо ваших товаров будут наши примеры.',
  },
];
